import React, {useEffect} from 'react';
import {
    AvatarContainer, CommentCardWrapper, UserComment, UserName, UserType
} from "./comment-card.styles";

const CommentCard = ({userProfile, userComment, userName, userType, rate}) => {

    useEffect(() => {

    }, []);

    return (
        <CommentCardWrapper>
            <AvatarContainer>
                <img src={userProfile} alt='user avatar' />
            </AvatarContainer>
            <UserComment className='mb-0 text-center text-lg-end'>{userComment}</UserComment>
            <div className='d-flex align-items-center justify-content-between mt-4'>
                <div>
                    <UserName>{userName}</UserName>
                    <UserType>{userType}</UserType>
                </div>
                <div>
                    {
                        Array.apply(null, Array(rate)).map((_, index) => (
                            <i className='icon-star' key={index} />
                        ))
                    }
                </div>
            </div>
        </CommentCardWrapper>
    );
};

export default CommentCard;
